import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import {
  logoutLaboTurnos,
  wsGetVerificarLaboGrupo,
  wsGetLaboTurnos,
} from "../../../context/Actions/turnos/laboTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { useHistory } from "react-router";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import {
  editaTurnosDisponibles,
  setFechaTurno,
} from "../../../context/Actions/turnos/turnosDisponibles";
import { IonSpinner } from "@ionic/react";
import fechaTurnoFormat from "../../../../global/utils/fechaTurnoFormat";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import "./BuscadorLaboratorio.css";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import {
  hideSegundoModal,
  showSegundoModal,
} from "../../../context/Actions/segundoModal/segundoModal";
import { GlobalContext } from "../../../../global/context/Provider";
import DropdownV2 from "_+_Portal/components/Genericos/DropdownV2/DropdownV2";

const BuscadorLaboratorio2 = ({
  listaDeterminaciones,
  onChangeMultitabMobile,
  buscadorTurnos,
}) => {
  const history = useHistory();

  const {
    laboGrupoState,
    modalDispatch,
    laboTurnosDispatch,
    laboTurnosState,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    listaFamiliaresState,
    selectDropDownState,
    segundoModalDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, toasterDispatch } = useContext(GlobalContext);

  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);

  const [idGrupo, setIdGrupo] = useState("");
  const [descGrupo, setDescGrupo] = useState("");
  const [flgParticular, setFlgParticular] = useState(false);
  const [flgGrupoOk, setFlgGrupoOk] = useState(false);
  const [fecha, setFecha] = useState();
  const [flgModal, setFlgModal] = useState(false);
  const [determinaciones, setDeterminaciones] = useState(listaDeterminaciones);
  const [deshabilitoBusq, setDeshabilitoBusq] = useState(false);
  const [OSAlternativa, setOSAlternativa] = useState(false);
  const [flgPushDisponibles, setFlgPushDisponibles] = useState(false);
  let dtoPOST = null;

  const dissmiss = () => {
    hideModal()(modalDispatch);
  };

  const dissmissSegundoModal = () => {
    hideSegundoModal()(segundoModalDispatch);
    setOSAlternativa(false);
  };

  const onChangeDatePicker = (e) => {
    setFecha(e);
    setFechaTurno(e)(turnosDisponiblesDispatch);
  };

  const onChangeBuscador = (e) => {
    if (e !== "") {
      setFlgModal(false);
      setFlgParticular(false);
      setFlgGrupoOk(false);
      if (e.id !== null && e.id !== undefined && e.id > 0) {
        setIdGrupo(e.id);
        setDescGrupo(e.descripcion);
        if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
          wsGetVerificarLaboGrupo(
            e.id,
            selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
            verificaLabo
          )(laboTurnosDispatch);
        } else {
          wsGetVerificarLaboGrupo(e.id, -1, verificaLabo)(laboTurnosDispatch);
        }
        setDeshabilitoBusq(false);
      }
    } else {
      setFlgModal(false);
      setFlgParticular(false);
      setFlgGrupoOk(false);
      setIdGrupo("");
      setDescGrupo("");
      setDeshabilitoBusq(true);
    }
  };

  const onBuscarTurnosClick = (filtro, centrosLabo) => {
    if (!flgModal) {
      if (filtro) {
        if (flgGrupoOk) {
          dtoPOST = {
            fechaInvertida: fecha,
            idGrupo: idGrupo,
            OsAlternativa: OSAlternativa ? OSAlternativa : false,
          };
          if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
            wsGetLaboTurnos(
              fecha,
              -1,
              -1,
              idGrupo,
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .id,
              (isCorrect, data) => verificaLabo(isCorrect, data, centrosLabo)
            )(laboTurnosDispatch);
          } else {
            wsGetLaboTurnos(
              fecha,
              -1,
              -1,
              idGrupo,
              -1,
              (isCorrect, data) => verificaLabo(isCorrect, data, centrosLabo)
            )(laboTurnosDispatch);
          }
          setFlgGrupoOk(false);
        }
      } else {
        showFiltrosLabo();
      }
    } else {
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        wsGetVerificarLaboGrupo(
          idGrupo,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id,
          verificaLabo
        )(laboTurnosDispatch);
      } else {
        wsGetVerificarLaboGrupo(idGrupo, -1, verificaLabo)(laboTurnosDispatch);
      }
    }
  };

  const cancelaParticular = () => {
    dissmiss();
    logoutLaboTurnos()(laboTurnosDispatch);
    setFlgParticular(false);
    setFlgModal(true);
    setFlgGrupoOk(false);
  };

  const cancelaAlternativa = () => {
    dissmiss();
    logoutLaboTurnos()(laboTurnosDispatch);
    setOSAlternativa(false);
    setFlgModal(true);
    setFlgGrupoOk(false);
  };

  const deterComoParticular = (origen) => {
    dissmiss();
    if (origen === "osAlternativa") {
      setOSAlternativa(true);
      showFiltrosLabo();
    }
    setFlgModal(false);
    setFlgGrupoOk(true);
    hideModal()(modalDispatch);
    logoutLaboTurnos()(laboTurnosDispatch);
  };

  const modalParticular = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Desea tomar el turno como particular?",
        texto: "El estudio seleccionado no figura dentro de tu cobertura",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaParticular,
        },
        {
          text: "Tomar como particular",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: deterComoParticular,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const modalOSAlternativa = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno con tu obra social alternativa?",
        texto: "La determinacion seleccionada no figura dentro de tu cobertura",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaAlternativa,
        },
        {
          text: "Tomar con OS alternativa",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: () => deterComoParticular("osAlternativa"),
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const onHandleBuscarTurnosLabo = (arrFiltros) => {
    hideSegundoModal()(segundoModalDispatch);
    onBuscarTurnosClick(true, arrFiltros);
  };

  const showFiltrosLabo = () => {
    //saco el domingo ya que no entra dentro de los dias.
    showSegundoModal(
      "Turnos/FiltrosLabo/FiltrosLabo",
      {
        titulo: "Filtrar por centro",
        dissmiss: dissmissSegundoModal,
        onHandleBuscarTurnosLabo: onHandleBuscarTurnosLabo,
      },
      {},
      "centro"
    )(segundoModalDispatch);
  };

  const modalAtencionSinTurnoPrevio = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "El estudio se realiza sin turno previo",
        textoNegrita: "Prueba",
        texto: "a Definir",
        dissmiss: dissmiss,
        danger: true,
      },
      [
        {
          text: "Salir",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: dissmiss,
        },
        {
          text: "Leer sobre turnos sin reserva",
          clase: "btn-Mensaje-1 rb16m bgc-latex30 c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const verificaLabo = (isCorrect, data, centrosLabo) => {
    if (isCorrect) {
      if (data.continua && data.circuito === "") {
        setFlgModal(false);
        setFlgGrupoOk(true);
        logoutLaboTurnos()(laboTurnosDispatch);
      } else if (
        data.data !== null &&
        data.data !== undefined &&
        data.data !== ""
      ) {
        // Mantener los filtros de centros tal como el usuario los configuró
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: data.data,
          grupoMedico: null,
          particular: flgParticular,
          idEstudio: idGrupo,
          descEstudio: descGrupo,
          descEspecialidad: null,
          fechaBusqueda: data.fechaBusqueda,
          dtoBusqueda: dtoPOST,
          volverOrigen: "LABORATORIO",
          proceso: "labo",
          filtrosData: {
            ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
            centrosLabo,
          },
        })(turnosDisponiblesDispatch);
        setFlgParticular(true);
        hideModal()(modalDispatch);
        setFlgPushDisponibles(true);
      }
    } else {
      if (data === "9") {
        setFlgParticular(true);
        setFlgModal(true);
        modalParticular();
        logoutLaboTurnos()(laboTurnosDispatch);
      } else if (data === "91") {
        setFlgModal(true);
        modalOSAlternativa();
        logoutLaboTurnos()(laboTurnosDispatch);
      } else if (data === "10") {
        modalAtencionSinTurnoPrevio();
        logoutLaboTurnos()(laboTurnosDispatch);
      } else {
        if (data !== "" && data !== null && data !== undefined) {
          if (data.length > 100) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Atención",
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data,
                    }}
                  ></div>
                ),
                dissmiss: dissmiss,
                danger: true,
              },
              [
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: cancelaParticular,
                },
              ],
              "centro"
            )(modalDispatch);
            logoutLaboTurnos()(laboTurnosDispatch);
          } else {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: "Información",
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data,
                    }}
                  ></div>
                ),
                dissmiss: dissmiss,
                danger: true,
              },
              [
                {
                  text: "Volver",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: cancelaParticular,
                },
              ],
              "centro",
              true
            )(modalDispatch);
            logoutLaboTurnos()(laboTurnosDispatch);
          }
        } else {
          showToaster(
            {
              texto: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: laboTurnosState.laboTurnos.error,
                  }}
                ></div>
              ),
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          logoutLaboTurnos()(laboTurnosDispatch);
        }
      }
    }
  };

  useEffect(() => {
    if (
      flgPushDisponibles &&
      turnosDisponiblesState?.turnosDisponibles?.turnosData?.turnos
    ) {
      history.push("/turnosDisponibles");
      setFlgPushDisponibles(false);
    }
  }, [flgPushDisponibles, turnosDisponiblesState.turnosDisponibles.turnosData]);

  useEffect(() => {
    if (laboGrupoState.laboGrupo.data !== null) {
      setDeterminaciones(laboGrupoState.laboGrupo.data);
      setFecha(fechaTurnoFormat());
    }
    if (
      laboGrupoState.laboGrupo.centros !== null &&
      laboGrupoState.laboGrupo.centros !== undefined
    ) {
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .centrosLabo !== undefined
      ) {
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
            .centrosLabo.length === 1
        ) {
          let centrosLabo =
            turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
              .centrosLabo;
          let centro = [
            ...new Set(
              laboGrupoState.laboGrupo.centros.map((item) => item.descripcion)
            ),
          ];
          let ubicacion = [
            ...new Set(
              laboGrupoState.laboGrupo.centros.map((item) => item.ubicacion)
            ),
          ];
          let coordenadas = [
            ...new Set(
              laboGrupoState.laboGrupo.centros.map((item) => item.coordenadaGps)
            ),
          ];
          const map = new Map();
          for (const item of centro) {
            for (const itemUbi of ubicacion) {
              for (const itemGps of coordenadas) {
                if (
                  !centrosLabo.filter(
                    (x) =>
                      x.descripcion === item &&
                      x.ubicacion === itemUbi &&
                      x.coordenadas === itemGps
                  ).length > 0
                ) {
                  if (
                    !map.has(item) &&
                    !map.has(itemUbi) &&
                    !map.has(itemGps)
                  ) {
                    map.set(item);
                    map.set(itemUbi);
                    map.set(itemGps);
                    //para colocar correctamente los id. tomo el ultimo item de la lista. cuyo id + 1.
                    const lastItem = centrosLabo[centrosLabo.length - 1];
                    centrosLabo.push({
                      id: lastItem.id + 1,
                      descripcion: item,
                      ubicacion: itemUbi,
                      coordenadas: itemGps,
                      checked: true,
                    });
                  }
                }
              }
            }
          }
          // guardo los centros
          editaTurnosDisponibles({
            ...turnosDisponiblesState.turnosDisponibles.turnosData,
            filtrosData: {
              ...turnosDisponiblesState.turnosDisponibles.turnosData
                .filtrosData,
              centrosLabo: centrosLabo,
            },
          })(turnosDisponiblesDispatch);
        }
      }
    }
  }, []);

  //agrego logica volver a verificar estudio/consMed por cambio de paciente.
  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      if (idGrupo !== "" && descGrupo !== "") {
        setFlgModal(false);
        setFlgParticular(false);
        setFlgGrupoOk(false);
        wsGetVerificarLaboGrupo(
          idGrupo,
          selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
        )(laboTurnosDispatch);
      }
    } else {
      if (idGrupo !== "" && descGrupo !== "") {
        setFlgModal(false);
        setFlgParticular(false);
        setFlgGrupoOk(false);
        wsGetVerificarLaboGrupo(idGrupo)(laboTurnosDispatch);
      }
    }
  }, [selectDropDownState.selectDropDown.selectGlobal]);

  // useEffect que hace que se elija general
  useEffect(() => {
    if (window.location.pathname === "/laboratorio" || buscadorTurnos) {
      onChangeBuscador(laboGrupoState.laboGrupo.data[0]);
    }
  }, []);

  useEffect(() => {
    if (
      determinaciones &&
      window.location.pathname === "/testpcr" &&
      idGrupo === ""
    ) {
      let objPCR = {
        descripcion: "PCR (HISOPADO)",
        id: 3,
        idusuario: "",
        idusuario_desc: null,
        orden: 2,
        reqcobroweb: false,
      };
      let arrx = [...determinaciones];
      arrx.push(objPCR);
      setDeterminaciones(arrx);
      onChangeBuscador(objPCR);
    }
  }, [determinaciones]);

  // Busca el dia de hoy para el datePicker
  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);

  const configDropdown = {
    data: determinaciones && determinaciones,
    header: "Seleccione el análisis a realizar",
    headerColor: buscadorTurnos && "c-white",
    footer: "",
    descripcion: "descripcion",
    placeholder:
      window.location.pathname !== "/laboratorio" ? "PCR (HISOPADO)" : "",
    placeHolderFontSize: 16,
    defaultValue:
      window.location.pathname === "/laboratorio" || buscadorTurnos
        ? "TURNO DE LABORATORIO GENERAL"
        : "PCR (HISOPADO)",
    defaultValueParametro: "descripcion",
    height: 38,
    cantidadItems: 10,
    maxlength: 100,
    error: null,
    arrow: true,
    search: false,
    disabled: false,
    tooltip: false,
    showUp: true,
    regex: /^[a-zA-Z\s]+$/,
  };

  return (
    <React.Fragment>
      {!buscadorTurnos && (
        <div className="ptur-buscadorLaboratorio-desktop-dropdown">
          <Dropdown
            valor={
              listaFamiliaresState.listaFamiliares.loading &&
              (listaFamiliaresState.listaFamiliares.data === null ||
                listaFamiliaresState.listaFamiliares.data === "")
                ? ""
                : !selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido
                ? authState.auth.data.paciente.codigo
                : selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.id
            }
            datos={dropdownFamiliares(
              listaFamiliaresState,
              authState,
              "ManejoTurnos"
            )}
            campoCodigo="id"
            descripcion="nombre"
            onChange={onChangeMultitabMobile}
            placeholder={
              listaFamiliaresState.listaFamiliares.loading &&
              (listaFamiliaresState.listaFamiliares.data === null ||
                listaFamiliaresState.listaFamiliares.data === "")
                ? "Cargando Familiares..."
                : ""
            }
            desactivado={
              listaFamiliaresState.listaFamiliares.loading &&
              (listaFamiliaresState.listaFamiliares.data === null ||
                listaFamiliaresState.listaFamiliares.data === "")
                ? true
                : false
            }
            heightLista={"auto"}
          />
        </div>
      )}

      <div
        className={
          buscadorTurnos
            ? "cuerpoPestaniaLaboratorioBuscadorTurno"
            : "cuerpoPestaniaLaboratorio"
        }
      >
        <div className="ptur-buscador-dropdown">
          <DropdownV2 config={configDropdown} onClick={onChangeBuscador} />
        </div>
        <div className="ptur-buscador-fecha-boton-laboratorio">
          <div className="ptur-buscador-fecha-laboratorio">
            <DatePicker
              fechaInicial={`${hoyDia.getFullYear()} ${
                hoyDia.getMonth() + 1
              } ${hoyDia.getDate()}`}
              fechaFinal={`${noventaDiasDespues.getFullYear()} ${
                noventaDiasDespues.getMonth() + 1
              } ${noventaDiasDespues.getDate()}`}
              headerStr={"Buscar fecha"}
              headerStrColor={buscadorTurnos && "c-white"}
              onChange={onChangeDatePicker}
              customCss="ptur-datePicker-laboratorio"
            />
          </div>
          <div className="ptur-buscador-boton-laboratorio">
            <button
              onClick={() => onBuscarTurnosClick(null)}
              className="ptur-btn-buscador-laboratorio bgc-primary c-white rb18m"
              disabled={laboTurnosState.laboTurnos.loading || deshabilitoBusq}
            >
              {laboTurnosState.laboTurnos.loading ? (
                <span className="ptur-buscadorEstudio-loading">
                  <IonSpinner name="lines-small" />
                </span>
              ) : (
                "Siguiente"
              )}
            </button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BuscadorLaboratorio2;
